import { useEffect, useState } from "react";
import Logo from "../Images/Logo.png";
// import backArrow from '../Images/back.png';
import { useNavigate } from "react-router-dom";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";

const Login = () => {
    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [validationError, setValidationError] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [status, setStatus] = useState({ message: "", type: "" });
    const [showModal, setShowModal] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setValidationError((prev) => ({ ...prev, [e.target.name]: "" }));
    };

    const validateForm = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        let error = {};

        if (!emailRegex.test(formData.email)) {
            error.email = "Please enter a valid email address.";
        }

        if (!formData.password) {
            error.password = "Password is needed to sign in.";
        }

        setValidationError(error);
        return Object.keys(error).length === 0;
    };

    const Login = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        setIsSubmitting(true);

        // 👇 1. ADD THIS LOG TO CHECK THE URL
        console.log(
            "Attempting login to URL:",
            `${process.env.REACT_APP_BACKEND_URL}/admin/login`,
        );

        try {
            const response = await fetch(
                `${process.env.REACT_APP_BACKEND_URL}/admin/login`,
                {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData),
                },
            );

            const data = await response.json();

            if (!response.ok || !data.token) {
                setShowModal(true);
                setStatus({
                    message:
                        data.detail || "Something went wrong! Try again later.",
                    type: "error",
                });
                return;
            }

            const token = data.token;
            localStorage.setItem("PhilomenaAdminToken", token);
            localStorage.setItem("tokenTimestamp", Date.now());
            navigate("/");
        } catch (error) {
            setShowModal(true);
            setStatus({
                message: "Something went wrong! Try again later.",
                type: "error",
            });

            // 👇 2. MAKE SURE THIS IS PRINTING THE FULL ERROR OBJECT
            console.error("Login error details:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    useEffect(() => {
        if (showModal) {
            const timer = setTimeout(() => {
                setShowModal(false);
                setStatus({ message: "", type: "" });
            }, 3500);

            return () => clearTimeout(timer);
        }
    }, [showModal]);

    return (
        <div className="w-full py-5 sm:px-10">
            <div className="relative flex flex-col h-full gap-10">
                <div className="flex items-center justify-between :ml-10">
                    <a href="/">
                        {/* <div className='flex items-center gap-2'>
                            <img className='sm:w-[116px] sm:h-[42px] w-[180px] h-[60px]' src={Logo} alt="" />
                        </div> */}
                        <div className="flex items-center gap-3">
                            {/* Corrected logo dimensions to maintain aspect ratio */}
                            <img
                                className="h-[56px] w-auto object-contain"
                                src={Logo}
                                alt="Logo"
                            />

                            {/* Added philomena admin text */}
                            <span className="text-xl font-bold tracking-wide text-gray-800 capitalize">
                                philomena admin
                            </span>
                        </div>
                    </a>
                    {/* <div onClick={() => navigate('https://philomena.events/')} className='rounded-xl border border-[#DEE0E3] py-1.5 px-2.5 flex items-center gap-1.5'>
                        <img src={backArrow} className='size-5' alt="" />
                        <p className='font-medium'>Back to Website</p>
                    </div> */}
                </div>
                <div className="mx-auto flex flex-col sm:w-[500px] max-w-[1100px] mt-20 w-full justify-center">
                    <p className="text-[#1D1C1F] text-[24px] :text-[30px] font-semibold">
                        Log in to your account
                    </p>
                    <form
                        onSubmit={Login}
                        className="flex flex-col gap-4 text-[14px] mt-5 :text-[28px] font-medium text-[#525154]"
                        action=""
                    >
                        {showModal && (
                            <div
                                className={`${status.type === "error" ? "bg-red-500" : "bg-green-500"} text-white absolute md:top-14 z-50 top-12 sm:right-6 right-2 p-3 rounded-md flex items-center text-center justify-between`}
                            >
                                <p className="text-[16px] :text-[22px] font-bold">
                                    {status.message}
                                </p>
                            </div>
                        )}
                        <div className="flex flex-col gap-[6px]">
                            <p className="font-medium text-[#525154] text-sm">
                                Email address
                            </p>
                            <input
                                className="w-full px-[14px] py-[8px] rounded-xl border bg-transparent placeholder:text-sm shadow-md shadow-[#14151A0D] border-[#D2D0D6]"
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Enter email address"
                            />
                            {validationError.email && (
                                <p className="text-[#EF4444] font-normal text-[14px] :text-[19px]">
                                    {validationError.email}
                                </p>
                            )}
                        </div>
                        <div className="flex flex-col gap-[6px]">
                            <p className="font-medium text-[#525154] text-sm">
                                Password
                            </p>
                            <div className="flex items-center">
                                <input
                                    className="w-full px-[14px] py-[8px] rounded-xl border bg-transparent placeholder:text-sm shadow-md shadow-[#14151A0D] border-[#D2D0D6]"
                                    onChange={handleChange}
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    value={formData.password}
                                    placeholder="Enter password"
                                />
                                {showPassword ? (
                                    <IoEyeOffOutline
                                        onClick={togglePasswordVisibility}
                                        className="ml-[-30px] size-4 cursor-pointer"
                                    />
                                ) : (
                                    <IoEyeOutline
                                        onClick={togglePasswordVisibility}
                                        className="ml-[-30px] size-4 cursor-pointer"
                                    />
                                )}
                            </div>
                            {validationError.password && (
                                <p className="text-[#EF4444] font-normal text-[14px] :text-[19px]">
                                    {validationError.password}
                                </p>
                            )}
                        </div>
                        {/* <p className='font-medium text-[#62259A] text-sm mt-[-10px]'>Forgot password?</p> */}
                        <div className="flex flex-col gap-3 mt-4">
                            <button
                                className={`text-white flex gap-3 text-sm items-center justify-center py-3 px-5 w-full rounded-xl ${isSubmitting ? "bg-[#d0cfd1]" : "bg-[#000000]"}`}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? "Loading..." : "Log in"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
